import { Loader, MultiSelect } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';
import { ReactNode } from 'react';

import { useGetFunnels } from '@/features/pages';

type Props = {
  value?: string[];
  required: boolean;
  placeholder: string;
  pageId: string;
  onSelect: (value: string[]) => void;
  error?: ReactNode | string;
};

export const FunnelsSelect = ({ value, required, placeholder, pageId, onSelect, error }: Props) => {
  const { data, isFetching: isLoading, error: funnelsError } = useGetFunnels({ pageId });

  const options = data
    ? data.funnels.map((funnel) => ({ value: funnel._id, label: funnel.name }))
    : [];

  return (
    <MultiSelect
      required={required}
      placeholder={placeholder}
      value={value}
      onChange={onSelect}
      leftSection={<IconFilter size="1rem" />}
      rightSection={isLoading ? <Loader size="xs" /> : null}
      comboboxProps={{
        withinPortal: true,
        transitionProps: { transition: 'pop', duration: 200, timingFunction: 'ease' },
      }}
      searchable
      disabled={!!funnelsError}
      data={options}
      error={error}
    />
  );
};
